import { createSlice } from "@reduxjs/toolkit";

const initialUsers = {
    isLoggedIn: null,
    username: "",
    name: "",
    surname: "",
    email: "",
    role: "",
    initials: "",
    userId: ""
}

const user = createSlice({
    name: "users",
    initialState: initialUsers,
    reducers: {
        changeIsLoggedIn(state, action) {
            state.isLoggedIn = action.payload;
            // Clear identity on logout so a stale name or role can't survive
            // into the next session.
            if (action.payload === false) {
                Object.assign(state, initialUsers, { isLoggedIn: false });
            }
        },
        saveUserData(state, action) {
            // Guarded: an empty or missing payload threw here and took the
            // whole app down during the initial session check.
            const payload = action.payload || {};
            state.role = payload.role ?? "";
            state.username = payload.username ?? "";
            state.name = payload.name ?? "";
            state.surname = payload.surname ?? "";
            state.email = payload.email ?? "";
            state.initials = payload.initials ?? "";
            state.userId = payload.user_id ?? payload.id ?? "";
        },
    }
})

export const usersActions = user.actions;

export default user.reducer
